@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title}}" [(visible)]="display" showEffect="fade" [modal]="true" appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <div class="container-md">
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
        </div>
      </div>
      <!-- #FORM BODY -->
      <div class="row mt-4">
        <div class="col-12">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                  {{'general.code' | translate}}
                </label>
          <input pInputText id="code" class="form-control custom-input" [(ngModel)]="entity.code" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                  {{'general.description' | translate}}
                </label>
          <input pInputText id="description" class="form-control custom-input" [(ngModel)]="entity.description" />
        </div>
      </div>
      <!-- COMPANY -->
      <div class="row mt-4">
        <div class="col-12">
          <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                  {{'drivers.table.company' | translate}}
              </label>
          <div class="p-0"></div>
          <p-select [options]='companyList' [(ngModel)]='entity.billingAccount'
            placeholder="{{'tableManagement.companies.company' | translate}}" dataKey='id'
            optionLabel='name' [style]="{'width':'250px'}" appendTo='body' [filter]="true" filterBy="name"
            (onChange)="onChangeCompany($event)" (onFilter)="onFilterCompany($event)">
          </p-select>
        </div>
      </div>
      <!-- ACTIVE -->
      <!-- ACTIVE -->
      @if (!isNew) {
        <div>
          <div class="row mt-3">
            <div class="col-12">
              <label for="vehicle-data-settings-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
              {{'general.enabled' | translate}}
            </label>
              <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
                type="checkbox" [(ngModel)]="cecoEnabled" [disabled]="!isNew" />
            </div>
          </div>
        </div>
      }
    </div>
  </div>
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="save()" i18n>
                        {{'general.save' | translate}}
                    </button>
            </div>
          }
          @if (isNew) {
            <div>
              <button class="btn custom-button" (click)="save()" i18n>
                        {{'general.create' | translate}}
                    </button>
            </div>
          }
        </div>
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="changeStatus(cecoEnabled)" i18n>
                        {{'general.changeStatus' | translate}}
                    </button>
            </div>
          }
        </div>
      </div>
    </ng-template>
</p-dialog>
}
